import { Toaster } from "@/components/ui/sonner";
import { WhatsNewAnnouncementDialog } from "@/components/whats-new/whats-new-announcement-dialog";
import { useAuthAxiosInterceptors } from "@/custom-axios-instance";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export const RootAppShell = ({ children }: { children: ReactNode }) => {
  useAuthAxiosInterceptors();

  return (
    <div className={cn("min-h-screen flex flex-col bg-background text-foreground")}>
      {children}
      <WhatsNewAnnouncementDialog />
      <Toaster richColors closeButton />
      {/* <TanStackRouterDevtools /> */}
    </div>
  );
};
